import {useRef} from 'react';
import PropTypes from 'prop-types';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import {useClickOutside} from 'lib/customHooks';
import '../../Task.scss';
import {useDispatch, useSelector} from 'react-redux';
import {getIsAspirateDispenseModalShown} from 'stores/selectors/virtualTraySelectors';
import {setSimpleTransferEditedType} from 'stores/actions/protocolEditorAction';

// #region InsertMixingTask
function InsertMixingTask({isSelected, runtimeMode, onDelete, isDragging, excludedComponentRef, task}) {
  const isAspirateDispenseModalShown = useSelector(getIsAspirateDispenseModalShown);
  const {number, ID} = task;
  const dispatch = useDispatch();

  const insertTaskRef = useRef(null);

  const onClickOutside = () => {
    if (!isAspirateDispenseModalShown) {
      onDelete(ID, false);
    }
    dispatch(setSimpleTransferEditedType(null));
  };

  useClickOutside(insertTaskRef, onClickOutside, excludedComponentRef);

  return (
    <TaskWrapper ref={insertTaskRef} isDragging={isDragging} isSelected={isSelected}>
      <TaskNumber number={number} isHighlighted={isSelected} />
      <div className="task-description">
        <span className="bold">Mixing - Choose Well</span>
      </div>
      {!runtimeMode && (
        <>
          <span />
          <span />
          <span />
        </>
      )}
    </TaskWrapper>
  );
}

InsertMixingTask.propTypes = {
  onDelete: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  runtimeMode: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
  excludedComponentRef: PropTypes.any.isRequired,
  task: PropTypes.object.isRequired,
};
// #endregion InsertMixingTask

export default InsertMixingTask;
